import Alpine from 'alpinejs';

export default function initializeAlpineJS() {
  window.Alpine = Alpine;
  Alpine.start();
}
